import React, { FunctionComponent } from 'react';

interface TickIconProps {
  className: string;
}

export const TickIcon: FunctionComponent<TickIconProps> = ({ className }) => {
  return (
    <svg
      width="101"
      height="101"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M72.95 27.9L40 60.85L22.05 42.95L15 50L40 75L80 35L72.95 27.9ZM50 0C22.4 0 0 22.4 0 50C0 77.6 22.4 100 50 100C77.6 100 100 77.6 100 50C100 22.4 77.6 0 50 0ZM50 90C27.9 90 10 72.1 10 50C10 27.9 27.9 10 50 10C72.1 10 90 27.9 90 50C90 72.1 72.1 90 50 90Z"
        fill="#25CA76"
      />
    </svg>
  );
};
